export { default } from "ember-stereo/-private/utils/has-equal-urls";
